import "./global"

import "@modules/_vendor/css/bootstrap-mobile.css"
// lds-grid10 needs to be imported after bootstrap-css, otherwise styles will break (bootstrap styles will overwrite lds-grid10 styles)
import "@modules/global/lds-grid10.css"
import "@modules/location/location-selector.css"
import "@modules/global/global-styles-mobile.css"
// TODO could be in global.ts but import order matters. There is a style in global-styles.mobile which makes the close x
// in ad-free modal white instead of dark. Fix at some point? cannot move as effects are unclear.
import "@modules/global/icon-styles.css"
import "../util/SlideMenuMobile"
import "@modules/header/login-notice-mobile.ts"
import "@modules/header/login-notice-mobile.css"
import "@modules/banner/sticky-banner/sticky-banner.ts"
import "@modules/banner/sticky-banner/sticky-banner-mobile-base.css"
import "@modules/banner/easterfun/easterfun-mobile.css"
import "@modules/banner/privatebeitraege/privatebeitraege-mobile.css"
import "@modules/banner/xmasfun/xmasfun-mobile.css"
import "@modules/banner/tasteTheStar/tastethestar-mobile.css"
import "@modules/banner/football-championship/football-championship-shirt-mobile.css"
import "@modules/banner/championship/championship-mobile.css"

//feedback form and other forms

import("@modules/form/forms")

import "@modules/form/feedback/feedback-form-mobile.css"
